import api from '../api/axios';

export interface SystemSetting {
  id: number;
  key: string;
  value: string;
  description?: string;
  category: string;
}

export const systemSettingService = {
  async getAll(params?: any) {
    const response = await api.get('/system-settings', { params });
    return response.data;
  },

  async getByKey(key: string) {
    const response = await api.get('/system-settings', {
      params: {
        filters: { key: { $eq: key } }
      }
    });
    return response.data?.data?.[0];
  },

  async upsert(key: string, value: string, description?: string, category?: string) {
    // Try to find existing
    const existing = await this.getByKey(key);
    
    if (existing) {
      const response = await api.put(`/system-settings/${existing.id}`, {
        data: { value, description, category }
      });
      return response.data;
    } else {
      const response = await api.post('/system-settings', {
        data: { key, value, description, category: category || 'general' }
      });
      return response.data;
    }
  },

  async getApprovalSettings() {
    const response = await api.get('/system-settings/approval-settings');
    return response;
  },

  async updateApprovalSettings(settings: any) {
    const response = await api.put('/system-settings/approval-settings', {
      data: settings
    });
    return response.data;
  },

  async getPendingApprovals(model: string) {
    const response = await api.get(`/system-settings/pending-approvals/${model}`);
    return response.data;
  },

  async approveItem(model: string, id: number) {
    const response = await api.post(`/system-settings/approve/${model}/${id}`);
    return response.data;
  },

  async rejectItem(model: string, id: number) {
    const response = await api.post(`/system-settings/reject/${model}/${id}`);
    return response.data;
  }
};

